import { Card, Button } from '../atoms'

export interface ErrorDisplayProps {
  title?: string
  message: string
  onRetry?: () => void
}

export const ErrorDisplay = ({
  title = 'Error',
  message,
  onRetry,
}: ErrorDisplayProps) => {
  return (
    <Card className="border-accent/50">
      <div className="text-accent font-semibold mb-2">{title}</div>
      <div className="text-text-muted text-sm mb-3">{message}</div>
      {onRetry && (
        <Button onClick={onRetry} variant="secondary" size="sm">
          Retry
        </Button>
      )}
    </Card>
  )
}
